import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import format from 'date-fns/format'

type Props = {
  startMonth: Date
  endMonth: Date
}

const RevenueCalendarLabel: FC<Props> = React.memo((props) => {
  const { startMonth, endMonth } = props

  return (
    <p className={styles.label__monthly}>
      {format(startMonth, 'yyyy年M月')}-{format(endMonth, 'M月')}
    </p>
  )
})

export default RevenueCalendarLabel
